/**
 * Interpreta o conteudo de um QR Code e decide o destino dentro do app.
 * Aceita:
 *  (A) URL direta              -> abre a URL
 *  (B) texto do ManiaCNC       -> "PROJ=...|CLI=...|PECA=P12345|NOME=..." -> /v?peca=&projeto=
 *  (C) id solto (ex.: P12345)  -> /v?peca=P12345
 */
export type QrDestino =
  | { type: 'url'; url: string }
  | { type: 'internal'; path: string };

export function resolveQr(textoRaw: string): QrDestino | null {
  const texto = (textoRaw ?? '').trim();
  if (!texto) return null;

  // (A) URL direta
  if (/^https?:\/\//i.test(texto)) {
    return { type: 'url', url: texto };
  }

  // (B) Texto pipe-delimitado do ManiaCNC
  if (texto.includes('|') || /(?:^|\|)\s*PECA\s*=/i.test(texto)) {
    const campos: Record<string, string> = {};
    for (const par of texto.split('|')) {
      const idx = par.indexOf('=');
      if (idx > -1) {
        const k = par.slice(0, idx).trim().toUpperCase();
        campos[k] = par.slice(idx + 1).trim();
      }
    }
    const peca = campos.PECA ?? campos.PIECE ?? campos.ID;
    const proj = campos.PROJ ?? campos.PROJETO;
    if (peca) {
      const qs = new URLSearchParams({ peca });
      if (proj) qs.set('projeto', proj);
      return { type: 'internal', path: `/v?${qs.toString()}` };
    }
  }

  // (C) Id solto
  if (/^[A-Za-z0-9_-]+$/.test(texto)) {
    return { type: 'internal', path: `/v?peca=${encodeURIComponent(texto)}` };
  }

  return null;
}
